import { Box } from '@cko/primitives';
import styled from 'styled-components';
export const FormFieldContainer = styled(Box) `
  &:not(:last-child) {
    margin-bottom: var(--layout-soybean);
  }
`;
